import { Reducer } from 'redux';
import { RomsState } from './interfaces';
import * as types from './types';

export const romsState: RomsState = { 
    roms: [],
    list: {},
    searchCriteria: {
        endDate: '',
        name: '',
        page: 1,
        size: 100,
        sortBy: 'desc',
        sortOn: 'name',
        startDate: ''
    }
};

export const romsReducer: Reducer<RomsState> = (state = romsState, action) => {
    switch (action.type) {
        case types.ROM_LIST__SET_SEARCH_CRITERIA_VALUE:
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    [ action.name ]: action.value
                }
            };
        case types.ROM_LIST__SET_ROM_LIST: {
            const roms = action.roms;
            const list = roms.reduce((accumulator, currentValue) => {
                const key = currentValue.name[ 0 ].toLocaleUpperCase();
                if (accumulator[ key]) {
                    accumulator[ key ].push(currentValue);
                } else { 
                    accumulator[ key ] = [ currentValue ];
                }
                return accumulator;
            }, {});
            return {
                ...state,
                list,
                roms
            };
        }
        case types.ROM_LIST__CLEAR_SEARCH_CRITERIA:
            return {
                ...state,
                searchCriteria: romsState.searchCriteria
            };
        default:
            return state;
    }
};
